module.exports = __webpack_public_path__ + "img/arm-header-icons-03.412c3fba.svg";